// src/utils/dateUtils.js

import { format, parseISO } from "date-fns";

export const formatDate = (date) => {
    if (!date) return "-";

    try {
        return format(parseISO(date), "dd-MMM-yyyy");
    } catch {
        return "-";
    }
};

export const formatTime = (date) => {
    if (!date) return "-";

    try {
        return format(parseISO(date), "hh:mm a");
    } catch {
        return "-";
    }
};

export const formatDateTime = (date) => {
    if (!date) return "-";

    try {
        return format(parseISO(date), "dd-MMM-yyyy hh:mm a");
    } catch {
        return "-";
    }
};